import React from 'react';
import styled from 'styled-components';
import Play from '../assets/play-big.svg';
import Stop from '../assets/stop.svg';
import media from '../style/media';
import Spinner from './Spinner';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 70px;
  position: relative;
  
  ${media.mobile`
    min-height: 80px;
    min-width: 80px;
    height: 80px;
    width: 80px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
    padding: 5px;
  `}
  
  ${media.tablet`
    height: 88px;
    width: 88px;
    background: none;
    box-shadow: none;
    padding: 0;
  `}
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, var(--cl-primary), var(--cl-secondary));
  border-radius: 50%;
  cursor: pointer;
  height: inherit;
  width: inherit;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  border: 3px solid white;
  
  ${media.mobile`
    height: 70px;
    width: 70px;
  `}
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.3);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
  }
`;

const Icon = styled.img`
  width: 40%;
  height: 40%;
  filter: brightness(0) invert(1);
  transition: all 0.3s ease;
  
  ${media.tablet`
    width: 35%;
    height: 35%;
  `}
`;

const ButtonLabel = styled.div`
  position: absolute;
  bottom: -35px;
  color: var(--cl-text);
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
  ${media.tablet`
    display: none;
  `}
`;

export interface IStartButton {
  /**
   *  Displays a spinner when isLoading is true
   */
  isLoading;
  /**
   *  function triggered on button click
   */
  onClick: () => void;
  /**
   *  Displays whether the current session state is measuring
   */
  isMeasuring: boolean;
}

const StartButton = ({ isLoading, onClick, isMeasuring }: IStartButton) => {
  return (
    <Container>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <Button onClick={onClick}>
            <Icon src={isMeasuring ? Stop : Play} />
          </Button>
          <ButtonLabel>
            {isMeasuring ? 'Stop Measurement' : 'Start Measurement'}
          </ButtonLabel>
        </>
      )}
    </Container>
  );
};

export default StartButton;
